import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

import {QueryResultApi, ResponseApiModel} from '../../shared';
import {ChacraGeo} from '../models';
import {ApiService} from '../../shared';
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ChacraGeoService extends ApiService<ChacraGeo>{
  protected dataKey = 'rendimientoGEO';
  protected objectKey = 'Chacras';
  protected sendObjectKey = 'chacras';
  protected sendObjectIdsKey = 'chacrasIds';
  protected idKey = 'Id';

  constructor(protected httpClient: HttpClient) {
    super(ChacraGeo, httpClient, 'apiSeguroUrl');
  }

  getGeo(from: string, params = null): Observable<QueryResultApi<ChacraGeo>> {
    return this.getItems(`query${from}`, this.dataKey, params, false).pipe(
      map(queryResults => {
        const queryResultsAux = {...queryResults};
        queryResultsAux.items = queryResultsAux.items.map(it => {
          let id = it[this.idKey];
          return {
            ...it,
            id,
            type: from,
            idUnico: `${id}-${from}`
          }
        });
        return queryResultsAux;
      })
    );
  }

  /**
   * Get list of elemnts.
   * @param method to call
   * @param dataKey Key for data in response
   * @param params params for request
   * @param addObject add object to url
   */
  getItems(method: string, dataKey: string, params = null, addObject = true): Observable<QueryResultApi<ChacraGeo>> {
    const url = this.getUrl(method, addObject);
    return this.httpClient.post<{ queryResults: ResponseApiModel }>(url, params)
      .pipe(
        map(results => results.queryResults),
        map(response => {

          const result = new QueryResultApi<ChacraGeo>();
          result.items = [];
          if (response.success) {
            const items: ChacraGeo[] = [];
            if (response[dataKey]) {
              let resp = JSON.parse(response[dataKey]);

              let idKeyAlias = this.idKey;
              if(resp['fieldAliases']){
                const fieldAliases = resp['fieldAliases'];
                idKeyAlias = Object.keys(fieldAliases).find(k => fieldAliases[k] === this.idKey);
              }

              if(resp['features']){
                resp['features'].forEach((data: any) => {
                  const model = new this.ctor();
                  const attributes = data.attributes;
                  if(attributes)
                    delete data.attributes;
                  model[this.idKey] = attributes[idKeyAlias] ? attributes[idKeyAlias] : '';
                  items.push({...model, ...data, ...attributes});
                });
              }
            }
            result.items = items;

            if(response.meta)
              result.meta = response.meta;
          } else {
            let description = `Error al obtener los ${this.dataKey}`;
            if (response.error && response.error.description) {
              description = response.error.description;
            }
            throw throwError(description);
          }

          result.success = response.success;
          return result;

        }),
        catchError(
          this.handleError
        )
      );
  }
}
